export const BANK_OPTIONS = [
  { bank: 'ABSA', paybill: '103030', account: 'ARISE-SHINE' },
  { bank: 'Equity', paybill: '247247', account: 'ARISESHINE' },
  { bank: 'KCB', paybill: '522522', account: 'ARISE SHINE LTD' },
  { bank: 'NCBA', paybill: '880100', account: 'ARISESHINE' },
  { bank: 'Cooperative', paybill: '400200', account: 'ARISE SHINE LOGISTICS' },
];
